module.exports = __webpack_public_path__ + "static/elaborate-e0e20a8f813439087117c2dc22aaad39.png";